<template>
  <v-app  >
      <cabecera/>
    <v-main style="background-color:#6D9886;" >
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <section class="ma-4">
      <v-row justify="center" align="center">
        <v-col cols="10">
          <v-row>
        <v-col v-for="neg in negocios" :key="neg.id" cols="12" lg="4" sm="12" md="4">
          <v-card color="#F2E7D5" elevation="10">
            <v-card-text>
              <v-img
                  :src="neg.logo270"
                  @click="$router.push({name:'negociossorteotag', params:{tag:neg.tag}})"
            /></v-card-text>
            <v-card-title><a  @click="$router.push({name:'negociossorteotag', params:{tag:neg.tag}})">{{neg.negocio}}</a></v-card-title>

          </v-card>
        </v-col></v-row></v-col>
      </v-row>
      </section>
    </v-main>
<piepagina />
  </v-app>
</template>

<script>
import Cabecera from "@/components/general/cabecera";
import Piepagina from "@/components/general/piepagina";
import Cabecerabaja from "@/components/general/cabecerabaja";
import {mapGetters} from "vuex";

export default {
  name: "sorteo",
  components: {Cabecerabaja, Piepagina, Cabecera},
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      inscritos:[],
      rest: false,
      overlay:false,
      currentIndex:0,
      hooperSettings: {
        itemsToShow: 1,
        centerMode: true,
        infiniteScroll: true,
        vertical: true,
        autoPlay:true,
        playSpeed: 10
      },
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      nombreentero:'',
      camporef1: false,
      camporef2:false,
      condiciones: '',
      escogido: true,
      labelbton:'Girar',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido Paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Dni',
      labelDistrito: 'Distrito',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de Nacimiento',
      labelEmail:'Email',
      labelSexo:'Sexo',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      interval:0,
      eventodisenio: {},
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Futura Bk BT',
        color: '#000000',
        paddingTop:'30px'
      },
      styleComponent:{
        color:'#000000',
      },
      styleCabecera:{
        color:'#000000',
        backgroundColor:'#ffffff'
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#000000',
        backgroundColor:'#ffffff',
        marginTop:'0px !important'
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      },
      tag:'',
      autoplay:true,
      referido:'',
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },

  computed:{
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      negocios: "negocios"
    })
  }
}
</script>
